module.exports = __webpack_public_path__ + "static/img/001.cfd0e63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cooperator/001.png
// module id = kut1
// module chunks = 0